module.exports = fox._r("images/slides/slide_3_5.jpg", __webpack_public_path__ + "images/slides/slide_3_5.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/slide_3_5.jpg
// module id = 520
// module chunks = 2